import React, { FC } from 'react';
import { AccordionEventKey } from 'react-bootstrap/AccordionContext';
import { Accordion } from 'react-bootstrap';
import OutstandingPerformanceAwardForm from '../forms/outstanding-performance-award';
import { useDispatch, useSelector } from 'react-redux';
import { EducationHistoryModel, OutstandingPerformanceAwardModel } from '../../../../shared/models/employee.model';
import { handleEmployeeSectionAddNewData } from '../../../../shared/utils/function-state';
import SectionAddRow from '../section-add-row';
import {
    getCurrentEmployee,
    getCurrentEmployeeEditProfile,
    getEmployeeAction
} from '../../../../shared/services/employee-service';

interface EmployeeOutstandingPerformanceAwardProps {
    defaultKey?: AccordionEventKey;
}

const EmployeeOutstandingPerformanceAward: FC<EmployeeOutstandingPerformanceAwardProps> = ({defaultKey = '0'}) => {
    const dispatch = useDispatch();
    const employee = useSelector(getCurrentEmployee);
    const employeeAction = useSelector(getEmployeeAction);

    const employeeEditProfile = useSelector(getCurrentEmployeeEditProfile);
    const haveSomeEditField = () => {
        if (employeeAction.type === 'view-edit-request') {
            const lengthNotSame = employee.outstanding_performance_awards.length !== employeeEditProfile.outstanding_performance_awards.length;

            if (lengthNotSame)
                return true;

            return employee.outstanding_performance_awards.some((data, index) => {
                return Object.keys(data).some(key => {
                    const kk = key as keyof OutstandingPerformanceAwardModel;
                    if (key === 'id' || key === 'employee_id' || key === 'created_at'  || key === 'updated_at' || key === 'from_id')
                        return false;
                    return employeeEditProfile.outstanding_performance_awards[index][kk] !== data[kk];
                });
            });
        }
        return false;
    };

    const onAddNewData = () => {
        const initData: OutstandingPerformanceAwardModel = {
            id: null,
            employee_id: null,
            name: null,
            year: null,
            file: null,
            new_file: true,
            file_name: '',
            from_id: null,
        };
        handleEmployeeSectionAddNewData('outstanding_performance_awards', initData, dispatch);
    };

    return (
        <Accordion defaultActiveKey={defaultKey} className="mt-3">
            <Accordion.Item eventKey="0">
                <Accordion.Header className={`text-mof-primary ${haveSomeEditField() ? 'accordion-warning' : ''}`}>
                    <h5 className="text-mof-primary m-0">ผลงานดีเด่น/รางวัล</h5>
                </Accordion.Header>
                <Accordion.Body>
                    <OutstandingPerformanceAwardForm/>
                    <SectionAddRow onAddNewData={onAddNewData}/>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default EmployeeOutstandingPerformanceAward;